import Ax from './axios';
import config from './config';

const API = config.BASE_API;

// 文档 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=33953056

export function getOrderList(data) {
  return Ax.post(`${API}/report/order`, data);
}

export function getEvOrderList(data) {
  return Ax.post(`${API}/report/evOrder`, data);
}

export function downloadOrderList(data) {
  return Ax.post(`${API}/report/order/download`, data);
}

export function downloadEvOrderList(data) {
  return Ax.post(`${API}/report/evOrder/download`, data);
}

export function getSummaryData(data) {
  return Ax.post(`${API}/report/summary`, data);
}

export function getEvSummaryData(data) {
  return Ax.post(`${API}/report/evSummary`, data);
}

export function downloadSummaryData(data) {
  return Ax.post(`${API}/report/summary/download`, data);
}

export function downloadEvSummaryData(data) {
  return Ax.post(`${API}/report/evSummary/download`, data);
}

export function getHeatMapGridsByCity(data) {
  return Ax.post(`${API}/chart/getHeatMapGridsByCity`, data);
}

export function getMonitorMapData(data) {
  return Ax.post(`${API}/chart/getMapAlerts`, data);
}

export function getEvHeatMapGridsByCity(data) {
  return Ax.post(`${API}/evBiChart/getHeatMapGridsByCity`, data);
}

export function getEvMonitorMapData(data) {
  return Ax.post(`${API}/evBiChart/getEvMapAlerts`, data);
}



// WEBPACK FOOTER //
// ./src/api/report.js